import { PaymentDetailsGeneralType } from '@/types/paymentDetailsTypes';
import { GeneralPaymentDetails } from './ui/GeneralPaymentDetails';
import { IntermediaryPaymentDetails } from './ui/IntermediaryPaymentDetails';
import { Box } from '@/components/Box/Box';
import { hasIntermediaryPaymentDetails } from '@/helpers/paymentDetailsHelpers';
import { DetailsRowNotes } from '@/components/DetailsWidget/DetailsRowNotes/DetailsRowNotes';

type PaymentDetailsDataType = {
  paymentDetails: PaymentDetailsGeneralType;
};

export const PaymentDetailsData = ({ paymentDetails }: PaymentDetailsDataType) => {
  if (!paymentDetails) return;

  const hasIntermediaryBank = hasIntermediaryPaymentDetails(paymentDetails);
  const notes = paymentDetails.internal_payment_details_data?.notes;

  return (
    <Box>
      <GeneralPaymentDetails paymentDetails={paymentDetails} />
      {hasIntermediaryBank && <IntermediaryPaymentDetails paymentDetails={paymentDetails} />}
      <Box marginTop='12px'>
        <DetailsRowNotes name='Notes'>{notes}</DetailsRowNotes>
      </Box>
    </Box>
  );
};
